import React from 'react';

import { Checkbox } from '@crehana/ui';

import { useTranslation } from '@crehana/i18n';

import { NewsLetterCheckBoxProps } from './types';

const NewsLetterCheckBox: React.FC<NewsLetterCheckBoxProps> = ({
  className,
  checkedNewsLetterTerms,
  setCheckedNewsLetterTerms,
  onCustomChange,
}) => {
  const { t } = useTranslation();
  const onChange = () => {
    if (onCustomChange) {
      onCustomChange({
        complete: !checkedNewsLetterTerms,
        value: !checkedNewsLetterTerms,
      });
    } else if (setCheckedNewsLetterTerms) {
      setCheckedNewsLetterTerms(!checkedNewsLetterTerms);
    }
  };

  return (
    <div className={className}>
      <div className="flex items-start mt-12">
        <Checkbox
          checked={checkedNewsLetterTerms}
          small
          onChange={onChange}
          data-testid="news-letter-checkbox"
        />
        <span className="ml-8 font-legals tw-font-semibold sm:text-left text-gray-dark">
          {t('CHECKBOX_DATA_USAGE')}
        </span>
      </div>
    </div>
  );
};

export default NewsLetterCheckBox;
